import { pipe } from 'ramda';

import {
  FETCH_USER_FORM,
  FETCH_USER_FORM_SUCCESS,
  FETCH_USER_FORM_ERROR,
  SAVE_USER_FORM,
  SAVE_USER_FORM_SUCCESS,
  SAVE_USER_FORM_ERROR,
  UPDATE_USER_FORM_FIELD,
  RESET_ERROR,
} from './constants';

const initialState = {
  isFetching: false,
  isSaving: false,
  isDirty: false,
  isValid: true,
  isSuccess: false,
  error: null,
  items: null,
};

const resetModificationFlags = (state) => {
  const items = state.items.map((block) => {
    const fields = block.fields.map((field) => ({
      ...field,
      isModified: false,
    }));

    return {
      ...block,
      fields,
    };
  });

  return {
    ...state,
    items,
  };
};

const validate = (state) => {
  const isValid = state.items.every((block) => block.fields.every((field) => !field.error));

  return {
    ...state,
    isValid,
  };
};

const updateFieldValue = (state, {
  blockId, fieldId, value, error, errorVars,
} = {}) => {
  if (state && state.items) {
    const { items } = state;
    const blockIndex = items.findIndex((item) => item.id === blockId);
    const block = items[blockIndex];

    if (block && block.fields) {
      const { fields } = block;
      const fieldIndex = fields.findIndex((field) => field.id === fieldId);
      const field = fields[fieldIndex];

      if (field) {
        return {
          ...state,
          isDirty: true,
          items: [
            ...items.slice(0, blockIndex),
            {
              ...block,
              fields: [
                ...fields.slice(0, fieldIndex),
                {
                  ...field,
                  error,
                  errorVars,
                  isModified: true,
                  value: error ? null : value,
                },
                ...fields.slice(fieldIndex + 1),
              ],
            },
            ...items.slice(blockIndex + 1),
          ],
        };
      }
    }
  }

  return state;
};

const updateField = pipe(updateFieldValue, validate);

const mapFields = (groups) => groups.map((g) => ({
  id: g.groupId,
  title: g.groupTitle,
  fields: g.fields.map((f) => ({
    ...f,
    label: f.title || '',
    type: f.type.replace('Date', 'datepicker').toLowerCase(),
    textType: f.valueType ? f.valueType.toLowerCase() : null,
    options: f.options ? f.options.map((o) => ({ label: o.value, value: o.code })) : null,
  })),
}));

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_FORM:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_USER_FORM_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isDirty: false,
        isValid: true,
        items: mapFields(action.data),
      };
    case FETCH_USER_FORM_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        items: null,
      };
    case SAVE_USER_FORM:
      return {
        ...state,
        isSaving: true,
      };
    case SAVE_USER_FORM_SUCCESS:
      return resetModificationFlags({
        ...state,
        isSaving: false,
        isDirty: false,
        isSuccess: true,
        error: null,
      });
    case SAVE_USER_FORM_ERROR:
      return {
        ...state,
        isSaving: false,
        error: action.error,
      };
    case UPDATE_USER_FORM_FIELD:
      return updateField(state, action.data);
    case RESET_ERROR:
      return {
        ...state,
        error: null,
        errorVars: null,
      };
    default:
      return state;
  }
}
